<div id="inicio">
</div>
<div class="caja">
  <img src="assets/img/banner2.jpg" class="img-fluid" alt="Responsive image">
  <div class="texto2">
    <br>
    <!-- <h1 class="font-weight-bold" style="font-size:5vw;">BIENVENIDO</h1> -->
  </div>
  <div class="texto">

    <h1 class="font-weight-light" style="font-size:5vw;">EL HUARACHE</h1>
    <h1 class="font-weight-bold" style="font-size:5vw; color: yellow;">SSABROSSÓN</h1>
    <!--   <button onclick="moverseA('abajo')" type="button" class="btn btn-outline-warning btn-lg">Ver Menú</button>
       -->
    <a href="/home/huarache#menu" id="btnMenu" class="btn btn-outline-warning btn-lg">Ver Menú</a>

  </div>


</div>
<br>
<br>
<div id="menu">
</div>
<div id="titleMenu">

  <h1 class="font-weight-bold text-center" style="font-size:3em;">Menú</h1>
</div>
<div class="container text-center">



  <br>
  <div class="row" >
    <div class="col" *ngFor="let product of products">
      <div class="card text-center d-flex justify-content-between aling-items-center" style="width: 18rem;">
        <img class="card-img-top" [src]="product.image" alt="Card image cap">
        <div class="card-body text-center">
          <h5 class="card-title">{{product.title}}</h5>
          <div id="textp">
            <!-- <span class="badge badge-info">{{product.descripcion}}</span> -->
            <p class="card-text">{{product.descripcion}}</p>
            
            <h6 class="font-weight-bold" id="alert" style="color: rgb(255, 255, 255);">{{product.p}}</h6>

          </div>


          <h2 class="font-weight-bold">{{product.precio | currency: 'MXN'}}</h2>

          <!--  <a routerLink= "/home/huarache" class="btn btn-dark">Ordenar</a> -->
        </div>
      </div>
    </div>


    <!-- <div class="col">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top" src="assets/img/rojo.jpg" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Huarache sencillo</h5>
          <p class="card-text">Huarache sencillo con salsa roja.</p>
          <h2 class="font-weight-bold">$12</h2>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top" src="assets/img/memelas.jpg" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Orden de memelas </h5>
          <p class="card-text">4 memelas con salsa roja</p>
          <h2 class="font-weight-bold">$16</h2>
        </div>
      </div>
    </div>

    <div class="col">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top" src="assets/img/memelas2.jpg" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Orden de memelas </h5>
          <p class="card-text">4 memelas con salsa verde</p>
          <h2 class="font-weight-bold">$16</h2>
        </div>
      </div>
    </div>

    <div class="col">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top" src="assets/img/memelas.jpg" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Orden de memelas </h5>
          <p class="card-text">4 memelas con salsa roja</p>
          <h2 class="font-weight-bold">$16</h2>
        </div>
      </div>
    </div>

    <div class="col">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top" src="assets/img/memelas.jpg" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Orden de memelas </h5>
          <p class="card-text">4 memelas con salsa roja</p>
          <h2 class="font-weight-bold">$16</h2>

        </div>
      </div>
    </div> -->



    <!-- Button trigger modal -->
    <div class="icon-wts-abajo">

      <img class="icon-wts" src="assets/img/wha.png" alt="" id="wtsicon" data-toggle="modal"
        data-target="#exampleModal">
      <h6>Ordena aquí</h6>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Desglosa tu orden aquí</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <br>
            <div>

              <i class="fas fa-motorcycle fa-lg" style="font-size: 50px;"></i>
              <br><br>
            </div>

            <div class="alert alert-primary" role="alert">
              <!-- Los envíos a domicilio generan un costo extra dependiendo tu zona, se te genara a conocer al realizar tu
              pedido. --> 
              El monto de envío varia de precio dependiendo tu zona y se da a conocer
              una vez realizando tu orden.<br><br>
            </div>


            <form id="formulario">
              <div class="form-group">
                <label for="formGroupExampleInput">Nombre:</label>
                <input type="text" class="form-control" id="formGroupExampleInput" placeholder="Nombre" required>
              </div>
              <div class="form-group">
                <label for="domicilioText">Domicilio:</label>
                <input type="text" class="form-control" id="domicilioText" placeholder="Domicilio" required>
              </div>


              <div class="form-group">
                <label for="exampleFormControlTextarea1">Escribe tu orden:</label>
                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" required></textarea>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancelar</button>
               <!--  <button id="submit" type="submit" class="boton"><i class="fab fa-whatsapp"></i> Enviar WhatsApp</button>
 -->
                <button id="sendbtn"  type="submit"  class="btn btn-success"> <i class="fab fa-whatsapp"></i> Enviar WhatsApp</button>
    
              </div>
            </form>





          </div>
          
        </div>
      </div>
    </div>




  </div>
</div>